var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-page"},[_c('basic-container',[_c('div',{staticClass:"welcome-box"},[_c('img',{staticClass:"welcome-bg",attrs:{"src":"https://joinstech-public.oss-cn-shenzhen.aliyuncs.com/1cc208474f76159630667dcebf3cb8b2","alt":"欢迎使用慧家云-家居商户运营平台"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }